<template>
    <div>
        <div v-for="(country,index) in countries" :key="'A' + index" :class="`country ${country.class}`">
            <div class="container">
                <div class="country-name d-none show-on-md">{{country.title}}</div>
                <div class="row-wrapper" :class="{ rowreverse: index % 2 !=0}">
                    <div class="col-left">
                        <div class="country-name hide-on-md">{{country.title}}</div>
                        <div class="statistics">
                            <ul v-for="(statistic,i) in country.statistics" :key="'B' + i">
                                <li>{{statistic.title}}</li>
                                <li v-html="statistic.value"></li>
                            </ul>
                        </div>
                    </div>
                    <div class="col-right">
                        <div class="image">
                            <svg class="img-fluid" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="456" height="423" viewBox="0 0 456 423">
                                <use :xlink:href="`#${country.mapsvgid}`"></use>
                            </svg>
                            <span class="countryFlag">
                                <img class="img-fluid" :src="require(`@/assets/images/flags/${country.flag}`)" :alt="country.title">
                            </span>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        props:{
            countries: Array
        },
        mounted(){
            console.log(this.countries);
        }
    }
</script>

<style lang="scss" scoped>
.country {
    // padding: rem(100px) 0;
    @media screen and (min-width:1025px){
        min-height: 750px;
    }
    @include flex(flex-start,center);
    @media screen and (max-width: 1600px) {
        padding: rem(80px) 0;
    }
    @media screen and (max-width:991px) {
        padding: rem(40px) 0;
    }
    .image {
        position: relative;
    }
    &.zainSsudan{
        .rowreverse{
            padding:0;
        }
    }
    
    .countryFlag {
        width: 55px;
        height: 55px;
        border-radius: 100%;
        border: 1px dashed #fff;
        position: absolute;
        left: 50%;
        top: 50%;
        transform: translate(-50%, -50%);
        img {
            position: absolute;
            top: 50%;
            left: 50%;
            transform: translate(-50%, -50%);
        }
    }
    &.first{
        padding-top: 0px;
    }
    &.zainBahrain {
        padding-bottom: rem(120px);
    }
}
.row-wrapper {
    display: flex;
    justify-content: space-between;
    padding-right: rem(100px);
    .col-right {
        padding-top: rem(100px);
        >.image {
            text-align: right;
        }
    }
    &.rowreverse {
        flex-direction: row-reverse;
        .col-right {
            >.image {
                text-align: left;
            }
        }
        @media screen and (min-width: 768px) and (max-width:1200px) {
            .col-left {
                text-align: right;
                text-align: -webkit-right;
            }
        }
    }
    @media screen and (max-width:1600px) {
        padding-right: rem(50px);
        .col-right {
            padding-top: rem(50px);
        }
    }
    @media screen and (max-width:1199px) {
        padding: 0 rem(40px);
    }
    @media screen and (max-width:991px) {
        .col-right {
            >.image {
                max-width: 300px;
            }
        }
    }
    @media screen and (max-width:991px) and (min-width:768px) {
        .col-left {
            flex: 0 0 320px;
            max-width: 320px;
        }
    }
    @media screen and (max-width:767px) {
        flex-direction: column-reverse !important;
        .col-right {
            >.image {
                text-align: center !important;
                margin: auto auto rem(20px) auto;
            }
        }
    }
}
.country-name {
    font-size: rem(100px);
    color: #fff;
    font-weight: 900;
    margin-bottom: rem(80px);
    line-height: 1;
    @media screen and (max-width: 1600px) {
        font-size: rem(70px);
        margin-bottom: rem(30px);
    }
    @media screen and (max-width:1200px) {
        font-size: rem(60px);
    }
    @media screen and (max-width:991px) {
        font-size: rem(55px);
    }
    @media screen and (max-width:767px) {
        justify-content: center;
        .hide-on-md {
            display: none;
        }
        .show-on-md {
            display: flex !important;
        }
    }
    @media screen and (max-width:575px) {
        font-size: rem(35px);
    }
}

.statistics {
    ul {
        border-bottom: 2px solid #17a773;
        padding: 16px 20px 16px 0;
        list-style: none;
        max-width: 300px;
        margin: 0;
        @include flex(center, space-between);
        li {
            color: #fff;
            font-size: rem(20px);
            font-weight: 500;
            text-transform: uppercase;
            &:last-child {
                font-weight: 700;
            }
        }
        @media screen and (max-width:1600px) {
            padding: 12px 20px 12px 0;
        }
    }
    @media screen and (max-width:991px) {
        ul {
            max-width: 100%;
        }
    }
}
.africa{
    .statistics {
        ul {
            border-bottom: 2px solid #00a6e4;
        }
    }
}
[lang="ar"]{
.row-wrapper {
    padding-left: rem(100px);
    padding-right:0;
    .col-right {
        >.image {
            text-align: left;
        }
    }
    &.rowreverse {
        .col-right {
            >.image {
                text-align: right;
            }
        }
        @media screen and (min-width: 768px) and (max-width:1200px) {
            .col-left {
                text-align: left;
                text-align: -webkit-left;
            }
        }
        @media screen and (max-width:1199px) {
            padding: 0 rem(40px);
        }
    }
    @media screen and (max-width:1600px) {
        padding-left: rem(50px);
        padding-right:0;
    }
    @media screen and (max-width:1199px) {
        padding: 0 rem(40px);
    }

    @media screen and (max-width:767px) {
        .col-right {
            >.image {
                text-align: center !important;
                margin: auto auto rem(20px) auto;
            }
        }
    }
}
.statistics {
    ul {
        padding: 16px 0 16px 20px;
        @media screen and (max-width:1600px) {
            padding: 12px 0px 12px 20px;
        }
    }
}
}
</style>